import React from 'react';
import Header from './components/Header';
import BentoGrid from './components/BentoGrid';
import { resources } from './data/resources';

function App() {
  return (
    <div className="min-h-screen bg-background dark:bg-darkBackground transition-colors duration-300 relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute inset-0 bg-grid-pattern-light dark:bg-grid-pattern bg-[length:40px_40px] pointer-events-none [mask-image:linear-gradient(to_bottom,black,transparent_80%)] opacity-30 dark:opacity-40"></div>
      <div className="absolute inset-0 bg-dot-pattern-light dark:bg-dot-pattern bg-[length:20px_20px] pointer-events-none [mask-image:linear-gradient(to_bottom,transparent_40%,black)] opacity-50 dark:opacity-100"></div>
      
      {/* Glowing orb effect in the background */}
      <div className="absolute top-[-10%] right-[-5%] w-[40rem] h-[40rem] rounded-full bg-trading-neon/10 dark:bg-trading-neon/5 blur-[100px] pointer-events-none animate-pulse" style={{ animationDuration: '8s' }}></div>
      <div className="absolute bottom-[-10%] left-[-5%] w-[40rem] h-[40rem] rounded-full bg-trading-green/5 dark:bg-trading-green/5 blur-[120px] pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <Header />
        
        <main>
          <BentoGrid resources={resources} />
        </main>
        
        <footer className="mt-32 pt-8 border-t border-gray-200 dark:border-gray-900 text-center text-gray-500 dark:text-gray-500 text-sm font-mono flex items-center justify-center gap-3 opacity-60 hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 px-2 py-1 rounded bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-gray-800">
            <span className="w-1.5 h-1.5 rounded-full bg-trading-green animate-pulse"></span>
            <span className="text-[10px]">SYS.ONLINE</span>
          </div>
          <p>© {new Date().getFullYear()} FOREX_RESOURCE_HUB. TERMINAL V1.0</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
